import { render, staticRenderFns } from "./MarketplaceButton.vue?vue&type=template&id=0502e21c&"
import script from "./MarketplaceButton.vue?vue&type=script&lang=js&"
export * from "./MarketplaceButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports